var randomEntry = function (array) {
    return array[Math.floor(Math.random() * array.length)];
};
var randomWords = ['Lorem', 'Ipsum', 'Dolor', 'Sit', 'Amet'];
var randomWord = function () { return randomEntry(randomWords); };
export var randomText = function (wordCount) {
    return Array(wordCount).fill(null).map(randomWord).join(' ');
};
export var defaultCompareValuesAsc = function (a, b, stringCompareOptions) {
    if (typeof a === 'number' && typeof b === 'number')
        return a - b;
    return JSON.stringify(a).localeCompare(JSON.stringify(b), undefined, stringCompareOptions);
};
export var defaultCompareValues = function (a, b, sortAsc, stringCompareOptions, compareValuesAsc) {
    return sortAsc
        ? compareValuesAsc(a, b, stringCompareOptions)
        : -1 * compareValuesAsc(a, b, stringCompareOptions);
};
//# sourceMappingURL=BasicTableUtils.js.map